import { Network } from '@aptos-labs/ts-sdk';
import { createCaasClient } from '@caas-xyz/core';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useCaasStore = defineStore('caas', () => {
  const client = createCaasClient({
    timeout: 5000,
    retries: 2,
    network: Network.TESTNET,
    fullnode: 'https://api.testnet.staging.aptoslabs.com/v1',
    domain: window.location.origin,
  });

  const isLoading = ref(false);
  const lastResult = ref<any>(null);
  const lastError = ref<string | null>(null);

  return {
    // State
    client,
    isLoading,
    lastResult,
    lastError,
  };
});
